module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh",
      "overflow-y": "hidden"
    },
    style: ({
      'background': 'linear-gradient(180deg, #22C9FE 0%, #0172F2 100%)'
    })
  }, [_c('div', {
    staticClass: "machine-head",
    staticStyle: {
      "font-size": "60px",
      "letter-spacing": "10px",
      "height": "120px",
      "line-height": "120px",
      "text-shadow": "2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000",
      "position": "relative"
    },
    style: ({
      'color': '#fff',
      'background': '#ea0000'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "margin-right": "10px",
      "position": "absolute"
    },
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.row.title) + "\n        出场顺序\n      ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "position": "absolute",
      "float": "right",
      "top": "20px",
      "right": "20px"
    },
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-image": "linear-gradient(#f9f400 0%, #f9f400 48%, #f9f400 100%)",
      "height": "100px",
      "letter-spacing": "0.2em",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "line-height": "100px",
      "margin": "10px",
      "text-align": "center",
      "color": "#000",
      "font-size": "50px",
      "padding": "0px 20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.row.saiqu_name))]), _vm._v(" "), _c('table', {
    staticClass: "machine-table",
    staticStyle: {
      "margin": "10px",
      "background-image": "linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%)"
    },
    style: ('overflow-y: auto;')
  }, [_c('thead', {
    style: ({
      'background': '#011fa7',
      'color': _vm.row.show_font_color_2
    })
  }, [_vm._m(0)]), _vm._v(" "), _c('tbody', {
    style: ('height:100%;overflow-y: scroll;')
  }, _vm._l((_vm.list), function(item, index) {
    return _c('tr', {
      key: item.id,
      style: ({
        'color': _vm.row.show_font_color_2,
        'background': index % 2 == 0 ? '#2143dd' : '#011fa7'
      })
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subject_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mingcheng))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("次序")]), _vm._v(" "), _c('th', [_vm._v("项目名称")]), _vm._v(" "), _c('th', [_vm._v("队伍名称")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e5775d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreStartList2.vue
// module id = 2213
// module chunks = 0